<br>
<div class="overflow-auto">
  <app-common-list-table
    [request]="env.showSdiClientes ? getRequestSdi : getRequest"
    [cols]="env.showSdiClientes ? colsSdi : cols"
    [filtering]="filtering"
    [globalConditionalStyle]="globalConditionalStyle"
    [globalVisualTransform]="globalVisualTransform"
    [actionButtonText]="env.canAddClients ? 'Añadir ' + env.clienteName : ''"
    (actionButtonClick)="add()"
    [customExportCsv]="env.showClientesCsv"
    (visualize)="show('info', $event)"
    (edit)="edit($event)"
    (remove)="show('delete', $event)">

    <!-- Header slot -->
    <ng-template #header>
      <div class="d-flex align-items-center gap-2">
        @if (env.applicationType === 'cropgest' && env.rol === 'admin') {
            <button
                type="button"
                class="btn btn-info btn-sm text-white ms-2 export-button"
                (click)="exportarClientes()"
            >
                <i class="fa fa-download"></i>
                <span class="ms-1">Exportar Clientes</span>
            </button>
        }

        @if (env.appName === 'hopsteiner') {
            <div>
                <button
                    type="button"
                    class="btn btn-info btn-sm"
                    (click)="downloadCsv()"
                >
                    <i class="fa fa-download"></i>
                    <span class="ms-1">Exportar listado</span>
                </button>
            </div>
        }

        @if (env.showMostrarTodosClientes) {
            <div class="d-flex align-items-center ms-3">
                <p-inputSwitch
                    class="me-2"
                    [(ngModel)]="env.showAllClients"
                    (onChange)="changeShowAll(); filtering.filter();">
                </p-inputSwitch>
                <span class="text-white mb-0">Mostrar todos</span>
            </div>
        }
      </div>
    </ng-template>

    <!-- Header extra columns -->
    <ng-template #thEnd>
        @if(env.showCuadernoDeCampoPorCliente) {
            <th><p class="d-flex justify-content-center mb-0">Cuaderno</p></th>
        }
        <th><p class="d-flex justify-content-center mb-0">Acciones</p></th>
        <th><p class="d-flex justify-content-center mb-0">{{ env.clientesName }}</p></th>
    </ng-template>

    <!-- Body extra columns -->
    <ng-template #tdEnd let-data>
        @if(env.showCuadernoDeCampoPorCliente) {
            <td>
                <div class="d-flex justify-content-center">
                <button
                    type="button"
                    (click)="show('generate', data)"
                    class="btn btn-primary btn-sm d-flex align-items-center"
                >
                    <i class="fa fa-book"></i>
                    <span class="ms-1">Generar</span>
                </button>
                </div>
            </td>
        }

      <td>
        <app-action-buttons
          [hideEdit]="!env.canEditClients"
          [hideDelete]="!env.canDeleteClients"
          (editRowButtonEvent)="edit(data.data)"
          (deleteRowButtonEvent)="unsetClientIfSelected(this.model.id); show('delete', data.data)"
          (showRowButtonEvent)="show('info', data.data)">
        </app-action-buttons>
      </td>

      <td>
        <div class="d-flex justify-content-center">
          <button
            type="button"
            (click)="selectClient(data.data)"
            class="d-flex justify-content-center align-items-center btn-client"
            [class.is-current]="data.data.id === currentClient?.id"
            [attr.aria-pressed]="data.data.id === currentClient?.id">
            <i
              class="fa"
              [class.fa-user]="data.data.id !== currentClient?.id"
              [class.fa-check]="data.data.id === currentClient?.id">
            </i>
            <span class="ms-1">{{ data.data.id !== currentClient?.id ? 'Seleccionar' : 'Actual' }}</span>
          </button>
        </div>
      </td>
    </ng-template>
  </app-common-list-table>
</div>

<app-modals
  [view]="this"
  [form]="form?.formFields"
  [serverUrl]="env.serverUrl"
  [previousData]="model"
  [recordHasAssociatedData]="model.tiene_datos"
  [getRequest]="getRequest"
  [deleteRequest]="deleteRequest">
</app-modals>

<!-- Dialog: Generar -->
@if(canShow['generate']) {
    <p-dialog
        header="Generar Word"
        [(visible)]="canShow['generate']"
        (onShow)="scrollToTop()">
        <div [style.width.vw]="50" class="min-vh-40">
            <app-form-builder
            [model]="model"
            [fields]="generarFields"
            [distributionColumns]="2">
            </app-form-builder>

            <div class="d-flex justify-content-center mt-3">
            <button class="btn btn-dark mx-2" type="button" (click)="hide('generate')">Cerrar</button>

            <button class="btn btn-primary mx-2" type="button" (click)="generarCuaderno()">Generar</button>

            @if(env.showFincasInformeTratamientos || (user?.nombre === 'ALEJANDRO' && env.appName === 'melia')) {
                <button
                    class="btn btn-secondary mx-3"
                    type="button"
                    (click)="generarCuaderno(true, false)">
                    Informe Tratamientos
                </button>
            }


            @if (env.showFincasLibroFertilizantes) {
                <button
                    class="btn btn-secondary mx-3"
                    type="button"
                    (click)="generarCuaderno(false, true)">
                    Generar Libro Fertilizantes
                </button>
            }
            </div>
        </div>
    </p-dialog>
}